import type { JSX } from 'react';

import styles from './HealthBadge.module.scss';
import type { TenantHealthScore } from '../api/metrics.graphql';
import { HEALTH_DEFINITION, RISK_LABELS, TREND_LABELS } from '../health-labels';

const TONE: Readonly<Record<TenantHealthScore['churnRisk'], string>> = {
  low: styles.low ?? '',
  medium: styles.medium ?? '',
  high: styles.high ?? '',
  new: styles.neutral ?? '',
  no_data: styles.neutral ?? '',
  not_operating: styles.neutral ?? '',
};

/**
 * OS-1724 — salud del tenant: puntaje y riesgo en texto (el color no es la única señal). Sin
 * puntaje dice por qué ("Sin datos de uso", "Nuevo (en gracia)") en vez de mostrar 0. La
 * definición va en `title` y en la sección del dashboard.
 */
export function HealthBadge({ health }: { health: TenantHealthScore }): JSX.Element {
  const risk = RISK_LABELS[health.churnRisk];
  const trend = health.trend ? ` · ${TREND_LABELS[health.trend]}` : '';
  const text = health.healthScore === null ? risk : `${health.healthScore} · ${risk}`;
  return (
    <span className={`${styles.badge} ${TONE[health.churnRisk]}`} title={HEALTH_DEFINITION}>
      {text}
      {trend ? <span className={styles.trend}>{trend}</span> : null}
    </span>
  );
}
